// @flow

import React, { type Node } from 'react';
import { getWeekDay } from '@tectonics/prs/week-day';
import { usePendingIncomingPayment, getSafeDueDate } from '@tectonics/prs/incoming-payment';
import { RenderTransferNode, RenderDepositNode } from './payment-option-components';
import { TextDisplay } from '../commons/text-display';
import { DisplayDueDate } from '../../../organisms/display-due-date';
import { DisplayTotalAmount } from '../../../organisms/display-total-amount';
import {
  DataBox,
  HeaderText,
  PaymentInfoWrapper,
} from '../../../organisms/shared-styled-components';
import { RenderPaymentInfoContainer } from '../../../organisms/payment-info-display';
import { VerticalAccordion } from '../../../organisms/vertical-accordion';

export function RenderTotalDueDateAndCIP(): Node {
  const incomingPayment = usePendingIncomingPayment();
  return (
    <PaymentInfoWrapper>
      <DisplayTotalAmount label="Valor a pagar" location="left" />
      <DisplayDueDate label="Fecha de Vencimiento" location="right" sublabel={`Paga hasta el ${getWeekDay(getSafeDueDate(incomingPayment), dueDateWeekDay)}`} redesign={true} />
      <DataBox>
        <TextDisplay title="Código de Pago CIP" value="cip" />
        <TextDisplay title="Empresa recaudadora" value="EBANX" />
        <TextDisplay title="Servicio" value="PagoEfectivo Soles" lastItem={true} />
      </DataBox>
    </PaymentInfoWrapper>
  );
}

export function RenderPaymentInstructions(): Node {
  return (
    <>
      <HeaderText>Instrucciones de pago</HeaderText>
      <>Elegí tu mejor opción para pagar y seguí las instrucciones:</>
      <VerticalAccordion initial="transferencia" items={[
        { id: 'transferencia', title: 'Transferencia', content: <RenderTransferNode /> },
        { id: 'deposito', title: 'Depósito', content: <RenderDepositNode /> },
      ]}/>

      <RenderPaymentInfoContainer
        bgColor="#ffffff"
        h1Text="Instrucciones de pago"
        items={[
          {
            imgSrc: 'https://cdn.ebanx.com/images/vouchers/calendar-icon.svg',
            subText: 'La confirmación del pago puede llevar aproximadamente 3 días hábiles para verse reflejado en el sitio web de la compra.',
          },
          {
            imgSrc: 'https://cdn.ebanx.com/images/vouchers/duplicate-icon.svg',
            subText: 'Este voucher es válido solamente para un código de pedido, no debe realizar un pago doble o uno de ellos será cancelado.',
          },
        ]}
      />
    </>
  );
}

const dueDateWeekDay = [
  'lunes',
  'lunes',
  'martes',
  'miércoles',
  'jueves',
  'viernes',
  'lunes',
];
